// noinspection JSAnnotator

export default {
	...(process.env.VUE_APP_ENV === 'local' && {
		local: {
			[environment.region]: {
				API: '/checkout-api',
				checkoutAPI: '/api/checkout/v1',
				wallet: `https://localhost.${environment.localEnv}-${environment.region.replace(
					'global',
					'www'
				)}.nexon.com:8100/wallet`,
				checkout: `https://localhost.${environment.localEnv}-${environment.region.replace(
					'global',
					'www'
				)}.nexon.com:8200/checkout`,
			},
		},
	}),
	dev: {
		global: {
			API: 'https://dev-www.nexon.com/checkout-api',
			checkoutAPI: 'https://dev-www.nexon.com/api/checkout/v1',
			wallet: 'https://dev-www.nexon.com/wallet',
			checkout: 'https://dev-www.nexon.com/checkout',
			payment: 'https://dev-payment.nxfs.nexon.com',
		},
		th: {
			API: 'https://dev-th.nexon.com/checkout-api',
			checkoutAPI: 'https://dev-th.nexon.com/api/checkout/v1',
			wallet: 'https://dev-th.nexon.com/wallet',
			checkout: 'https://dev-th.nexon.com/checkout',
			payment: 'https://dev-payment.nxfs.nexon.com',
		},
		tw: {
			API: 'https://dev-tw.nexon.com/checkout-api',
			checkoutAPI: 'https://dev-tw.nexon.com/api/checkout/v1',
			wallet: 'https://dev-tw.nexon.com/wallet',
			checkout: 'https://dev-tw.nexon.com/checkout',
			payment: 'https://dev-payment.nxfs.nexon.com',
		},
		sea: {
			API: 'https://dev-sea.nexon.com/checkout-api',
			checkoutAPI: 'https://dev-sea.nexon.com/api/checkout/v1',
			wallet: 'https://dev-sea.nexon.com/wallet',
			checkout: 'https://dev-sea.nexon.com/checkout',
			payment: 'https://dev-payment.nxfs.nexon.com',
		},
	},
	testPre: {
		global: {
			API: 'https://test-pre-www.nexon.com/checkout-api',
			checkoutAPI: 'https://test-pre-www.nexon.com/api/checkout/v1',
			wallet: 'https://test-pre-www.nexon.com/wallet',
			checkout: 'https://test-pre-www.nexon.com/checkout',
			payment: 'https://test-pre-payment.nxfs.nexon.com',
		},
		th: {
			API: 'https://test-pre-th.nexon.com/checkout-api',
			checkoutAPI: 'https://test-pre-th.nexon.com/api/checkout/v1',
			wallet: 'https://test-pre-th.nexon.com/wallet',
			checkout: 'https://test-pre-th.nexon.com/checkout',
			payment: 'https://test-pre-payment.nxfs.nexon.com',
		},
		tw: {
			API: 'https://test-pre-tw.nexon.com/checkout-api',
			checkoutAPI: 'https://test-pre-tw.nexon.com/api/checkout/v1',
			wallet: 'https://test-pre-tw.nexon.com/wallet',
			checkout: 'https://test-pre-tw.nexon.com/checkout',
			payment: 'https://test-pre-payment.nxfs.nexon.com',
		},
		sea: {
			API: 'https://test-pre-sea.nexon.com/checkout-api',
			checkoutAPI: 'https://test-pre-sea.nexon.com/api/checkout/v1',
			wallet: 'https://test-pre-sea.nexon.com/wallet',
			checkout: 'https://test-pre-sea.nexon.com/checkout',
			payment: 'https://test-pre-payment.nxfs.nexon.com',
		},
	},
	test: {
		global: {
			API: 'https://test-www.nexon.com/checkout-api',
			checkoutAPI: 'https://test-www.nexon.com/api/checkout/v1',
			wallet: 'https://test-www.nexon.com/wallet',
			checkout: 'https://test-www.nexon.com/checkout',
			payment: 'https://test-payment.nxfs.nexon.com',
		},
		th: {
			API: 'https://test-th.nexon.com/checkout-api',
			checkoutAPI: 'https://test-th.nexon.com/api/checkout/v1',
			wallet: 'https://test-th.nexon.com/wallet',
			checkout: 'https://test-th.nexon.com/checkout',
			payment: 'https://test-payment.nxfs.nexon.com',
		},
		tw: {
			API: 'https://test-tw.nexon.com/checkout-api',
			checkoutAPI: 'https://test-tw.nexon.com/api/checkout/v1',
			wallet: 'https://test-tw.nexon.com/wallet',
			checkout: 'https://test-tw.nexon.com/checkout',
			payment: 'https://test-payment.nxfs.nexon.com',
		},
		sea: {
			API: 'https://test-sea.nexon.com/checkout-api',
			checkoutAPI: 'https://test-sea.nexon.com/api/checkout/v1',
			wallet: 'https://test-sea.nexon.com/wallet',
			checkout: 'https://test-sea.nexon.com/checkout',
			payment: 'https://test-payment.nxfs.nexon.com',
		},
	},
	pre: {
		global: {
			API: 'https://pre-www.nexon.com/checkout-api',
			checkoutAPI: 'https://pre-www.nexon.com/api/checkout/v1',
			wallet: 'https://pre-www.nexon.com/wallet',
			checkout: 'https://pre-www.nexon.com/checkout',
			payment: 'https://pre-payment.nxfs.nexon.com',
		},
		th: {
			API: 'https://pre-th.nexon.com/checkout-api',
			checkoutAPI: 'https://pre-th.nexon.com/api/checkout/v1',
			wallet: 'https://pre-th.nexon.com/wallet',
			checkout: 'https://pre-th.nexon.com/checkout',
			payment: 'https://pre-payment.nxfs.nexon.com',
		},
		tw: {
			API: 'https://pre-tw.nexon.com/checkout-api',
			checkoutAPI: 'https://pre-tw.nexon.com/api/checkout/v1',
			wallet: 'https://pre-tw.nexon.com/wallet',
			checkout: 'https://pre-tw.nexon.com/checkout',
			payment: 'https://pre-payment.nxfs.nexon.com',
		},
		sea: {
			API: 'https://pre-sea.nexon.com/checkout-api',
			checkoutAPI: 'https://pre-sea.nexon.com/api/checkout/v1',
			wallet: 'https://pre-sea.nexon.com/wallet',
			checkout: 'https://pre-sea.nexon.com/checkout',
			payment: 'https://pre-payment.nxfs.nexon.com',
		},
	},
	prod: {
		global: {
			API: 'https://www.nexon.com/checkout-api',
			checkoutAPI: 'https://www.nexon.com/api/checkout/v1',
			wallet: 'https://www.nexon.com/wallet',
			checkout: 'https://www.nexon.com/checkout',
			payment: 'https://payment.nxfs.nexon.com',
		},
		th: {
			API: 'https://th.nexon.com/checkout-api',
			checkoutAPI: 'https://th.nexon.com/api/checkout/v1',
			wallet: 'https://th.nexon.com/wallet',
			checkout: 'https://th.nexon.com/checkout',
			payment: 'https://payment.nxfs.nexon.com',
		},
		tw: {
			API: 'https://tw.nexon.com/checkout-api',
			checkoutAPI: 'https://tw.nexon.com/api/checkout/v1',
			wallet: 'https://tw.nexon.com/wallet',
			checkout: 'https://tw.nexon.com/checkout',
			payment: 'https://payment.nxfs.nexon.com',
		},
		sea: {
			API: 'https://sea.nexon.com/checkout-api',
			checkoutAPI: 'https://sea.nexon.com/api/checkout/v1',
			wallet: 'https://sea.nexon.com/wallet',
			checkout: 'https://sea.nexon.com/checkout',
			payment: 'https://payment.nxfs.nexon.com',
		},
	},
};
